import { Textarea } from '@klear/ui/components/textarea'
import { Label } from '@klear/ui/components/label'
import type { LucideIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import { cn } from '@klear/ui/lib/utils'
import get from 'lodash/get'

interface FormTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string
  name: string
  icon?: LucideIcon
  disabled?: boolean
  isEditing?: boolean
  helperText?: string
}

export default function FormTextarea({
  label,
  name,
  icon: Icon,
  disabled,
  isEditing = true,
  className,
  helperText,
  ...props
}: FormTextareaProps) {
  const {
    register,
    formState: { errors }
  } = useFormContext()

  const fieldError = get(errors, name)
  const errorMessage = get(fieldError, 'message')

  return (
    <div className="space-y-2">
      <Label htmlFor={name} className="flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4" />}
        {label}
      </Label>
      <Textarea
        id={name}
        {...register(name)}
        disabled={disabled || !isEditing}
        className={cn(fieldError && 'border-destructive', className)}
        {...props}
      />
      {helperText && <p className="text-sm text-muted-foreground">{helperText}</p>}
      {errorMessage && <p className="text-sm text-destructive">{errorMessage.toString()}</p>}
    </div>
  )
}
